/* src/app/account/account-allocations/accounts-receivable-contract/accounts-receivable-contract.component.scss */
/*# sourceMappingURL=accounts-receivable-contract.component.css.map */
